export const USER_SESSION = "USER_SESSION";
export const USER_SESSION_IS_LOADING = "USER_SESSION_IS_LOADING";
export const USER_SESSION_LOADED = "USER_SESSION_LOADED";
export const REFERRALS = "REFERRALS";
export const REFERRALS_ARE_LOADING = "REFERRALS_ARE_LOADING";

export const USER_CONSULT_INFO = "USER_CONSULT_INFO";
